import React, { useMemo, useState } from "react";
import { MediaCard } from "./ot";

// ---- 子元件：單一卡片 ----
export default function BaseFileUpload1({
    showComponent = ["MediaCard"],
    MediaCardPorps = []
}) {

    return (
        <>
            {
                showComponent.includes("MediaCard") && (
                    <>
                        {
                            MediaCardPorps.map((item, index) => {
                                return (
                                    <MediaCard
                                        {...item}
                                    />
                                )
                            })

                        }
                    </>
                )

            }
        </>

    );
}